// Chọn email người mua trước khi gửi bảng kê cho kế toán duyệt.
// Danh sách lấy từ buyer của API chi tiết; vẫn cho nhập email mới, chỉ 1 email.
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { IS_TEST, IS_TEST_BUYER_EMAILS } from "../constants";
import { isValidEmail, readBuyerEmails } from "../helper";

const OTHER_EMAIL = "__other__";

const SubmitApprovalModal = props => {
  const { isOpen, toggle, buyer, code, isSubmitting, onConfirm } = props;

  // BE chưa trả email người mua; khi thử nghiệm thì dùng danh sách giả để
  // vẫn bấm được hết luồng
  const buyerEmails = readBuyerEmails(buyer);
  const emails =
    buyerEmails.length > 0 || !IS_TEST ? buyerEmails : IS_TEST_BUYER_EMAILS;
  // "Email khác" đứng đầu danh sách, chọn nó thì hiện ô nhập bên dưới
  const otherOption = { value: OTHER_EMAIL, label: "Email khác" };
  const options = [
    otherOption,
    ...emails.map(email => ({ value: email, label: email })),
  ];
  const [selected, setSelected] = useState(otherOption);
  const [otherEmail, setOtherEmail] = useState("");
  const [error, setError] = useState("");

  // Mở modal thì chọn sẵn email đầu tiên của người mua, không có thì Email khác
  useEffect(() => {
    if (!isOpen) return;
    setSelected(emails.length > 0 ? options[1] : otherOption);
    setOtherEmail("");
    setError("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, buyer]);

  const isOther = selected?.value === OTHER_EMAIL;

  const handleConfirm = () => {
    const email = (isOther ? otherEmail : selected?.value || "").trim();
    if (!email) {
      setError("Vui lòng chọn hoặc nhập email người mua");
      return;
    }
    if (!isValidEmail(email)) {
      setError("Email không hợp lệ");
      return;
    }
    setError("");
    onConfirm(email);
  };

  return (
    <Modal isOpen={isOpen} role="dialog" autoFocus centered toggle={toggle}>
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          Gửi duyệt bảng kê
          {code && <span className="text-primary ms-2">{code}</span>}
        </ModalHeader>
        <ModalBody>
          <div className="text-muted font-size-15 mb-2 fw-bold">
            Email người mua nhận link ký HĐ
          </div>

          <Select
            options={options}
            value={selected}
            onChange={option => {
              setSelected(option);
              setError("");
            }}
            placeholder="Chọn email người mua"
            noOptionsMessage={() => "Không có email phù hợp"}
            // Dropdown phải nổi trên modal (z-index modal của Bootstrap là 1050)
            menuPortalTarget={document.body}
            styles={{ menuPortal: base => ({ ...base, zIndex: 1060 }) }}
          />

          {isOther && (
            <input
              type="email"
              className={`form-control mt-2 ${error ? "is-invalid" : ""}`}
              placeholder="Nhập email người mua"
              value={otherEmail}
              onChange={event => {
                setOtherEmail(event.target.value);
                setError("");
              }}
            />
          )}

          {error && <MessageFormValidate error={error} />}
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="secondary"
            outline
            disabled={isSubmitting}
            onClick={toggle}
          >
            Hủy
          </Button>
          <Button
            type="button"
            color="primary"
            disabled={isSubmitting}
            onClick={handleConfirm}
          >
            <i className="bx bx-send me-1" />
            {isSubmitting ? "Đang gửi..." : "Xác nhận gửi duyệt"}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

SubmitApprovalModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  buyer: PropTypes.object,
  code: PropTypes.string,
  isSubmitting: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
};

SubmitApprovalModal.defaultProps = {
  isOpen: false,
  buyer: null,
  code: "",
  isSubmitting: false,
};

export default SubmitApprovalModal;
